<script>
import { mapGetters } from 'vuex';
import BarChart from 'shared/components/charts/BarChart.vue';
import { GROUP_BY_FILTER } from './constants';
import { formatDateChart, formatWeekRange } from 'shared/helpers/dateFormatter';

// Dedicated card for official WhatsApp template sends, branded green. Reads the
// template_messages_count series already in the store.
const WHATSAPP_GREEN = 'rgb(37, 211, 102)';

export default {
  name: 'WhatsAppTemplatesCard',
  components: { BarChart },
  props: {
    groupBy: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({ accountReport: 'getAccountReports' }),
    whatsappGreen() {
      return WHATSAPP_GREEN;
    },
    series() {
      return this.accountReport.data.template_messages_count || [];
    },
    total() {
      return this.series.reduce((acc, el) => acc + (Number(el.value) || 0), 0);
    },
    isFetching() {
      return this.accountReport.isFetching.template_messages_count;
    },
    collection() {
      return {
        labels: this.series.map(el => this.formatLabel(el.timestamp)),
        datasets: [
          {
            type: 'bar',
            label: this.$t('REPORT.WHATSAPP_TEMPLATES.TITLE'),
            backgroundColor: WHATSAPP_GREEN,
            data: this.series.map(el => el.value),
          },
        ],
      };
    },
    chartOptions() {
      return {
        scales: {
          x: { grid: { drawOnChartArea: false } },
          y: {
            type: 'linear',
            position: 'left',
            beginAtZero: true,
            grid: { drawOnChartArea: false },
          },
        },
      };
    },
  },
  methods: {
    formatLabel(timestamp) {
      const period = this.groupBy?.period;
      if (period === GROUP_BY_FILTER[2].period) {
        return formatWeekRange(timestamp);
      }
      if (period === GROUP_BY_FILTER[3].period) {
        return formatDateChart(timestamp, 'month');
      }
      if (period === GROUP_BY_FILTER[4].period) {
        return formatDateChart(timestamp, 'year');
      }
      return formatDateChart(timestamp, 'day');
    },
  },
};
</script>

<template>
  <div
    class="px-6 py-5 border-l-4 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2"
    :style="{ borderLeftColor: whatsappGreen }"
  >
    <div class="flex items-center gap-2">
      <span
        class="i-ri-whatsapp-fill size-5"
        :style="{ color: whatsappGreen }"
      />
      <span class="text-base font-medium text-n-slate-12">
        {{ $t('REPORT.WHATSAPP_TEMPLATES.TITLE') }}
      </span>
    </div>
    <div class="mt-2 text-2xl font-semibold text-n-slate-12">
      {{ total.toLocaleString() }}
    </div>

    <div class="mt-4 h-72">
      <woot-loading-state
        v-if="isFetching"
        class="text-xs"
        :message="$t('REPORT.LOADING_CHART')"
      />
      <div v-else class="flex items-center justify-center h-72">
        <BarChart
          v-if="series.length"
          :collection="collection"
          :chart-options="chartOptions"
        />
        <span v-else class="text-sm text-n-slate-10">
          {{ $t('REPORT.WHATSAPP_TEMPLATES.NO_DATA') }}
        </span>
      </div>
    </div>
  </div>
</template>
